import { createSelector } from "reselect";
import type { AIData } from "../actions/AIAssistantActions";
import type { AIState } from "../reducers/AIAssistantReducers";

/** Минимальный срез стора, который нужен селектору */
interface RootStateWithAI {
  ai: AIState;
}

const getAIData = (state: RootStateWithAI): AIData | null => state.ai.data;

export const AiSelector = createSelector(
  [getAIData],
  (data): AIData | null => data
);
